import React from 'react';
import styled from 'styled-components/macro';
import { Gallery } from 'src/client/components/splash/Network/Gallery';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { SplashGalleryResponse } from 'src/@types/Splash';
import { CoverAttributes } from 'src/client/helpers/urls/useGetGalleryCoverUrl';

type Props = {
  updates: SplashGalleryResponse[];
  updatesPrefix: string;
  updatesPrefixHover: string;
  updatesMax: number;
  coverAttributes: CoverAttributes;
  coverAttributesHover: CoverAttributes;
};

export const GalleryUpdates = (props: Props) => {
  const { contentCdnUrl } = useSelector((state) => state.app);

  const { updates, updatesMax } = props;

  const sites = useSelector((state) =>
    state.sites.items.reduce((key, site) => {
      key[site.UUID] = site.name;
      return key;
    }, {}),
  );

  return (
    <Div>
      {updates &&
        updates.slice(0, updatesMax).map((gallery) => {
          const { type, name, publishedAt, models, path, imageCount, runtime, siteUUID } = gallery;

          const galleryVideoUrlString = `${contentCdnUrl}/${gallery.siteUUID}/media/${gallery.UUID}/tease_preview_${gallery.UUID}.mp4`;
          const formattedPublishedAt = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          }).format(new Date(publishedAt));

          return (
            <Gallery
              coverAttributes={props.coverAttributes}
              coverAttributesHover={props.coverAttributesHover}
              gallerySite={sites[siteUUID]}
              galleryUrl={path}
              galleryVideoUrl={galleryVideoUrlString}
              imageCount={imageCount}
              key={gallery.UUID}
              models={models.map((model) => model.name).join(', ')}
              publishedAt={formattedPublishedAt}
              runtime={runtime}
              siteUUID={gallery.siteUUID}
              title={name}
              type={type}
              UUID={gallery.UUID}
            />
          );
        })}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: -15px;

  @media (max-width: 1024px) {
    margin-left: 0;
  }

  .GALLERY {
    max-width: 19%;

    @media (max-width: 1600px) {
      max-width: 24%;
    }

    @media (max-width: 768px) {
      max-width: 32%;
    }

    @media (max-width: 430px) {
      max-width: 95%;
    }
  }

  .MOVIE {
    max-width: 32%;
    @media (max-width: 768px) {
      max-width: 48%;
    }

    @media (max-width: 430px) {
      max-width: 95%;
    }
  }
`;
